const METRIC_SELECT_BOX_CLASS = '.dbi_metric_select-box';
const METRIC_FILTER_OVERLAY_BOX_SELECTOR =
  '.dbi-metric-select-auto-scroll-overlay .tea-dropdown-box, .dbi-kpi-trends-metric-filter-overlay .tea-dropdown-box';

const getScrollTarget = (selectorNode?: HTMLElement | null) => {
  const metricSelectBox = selectorNode?.closest(METRIC_SELECT_BOX_CLASS);
  let currentNode = metricSelectBox instanceof HTMLElement ? metricSelectBox : selectorNode;

  while (currentNode && currentNode !== document.body) {
    if (currentNode.previousElementSibling instanceof HTMLElement) {
      return currentNode.previousElementSibling;
    }
    currentNode = currentNode.parentElement;
  }

  return selectorNode;
};

const getScrollableContainer = (node?: HTMLElement | null) => {
  let currentNode = node?.parentElement;

  while (currentNode && currentNode !== document.body) {
    const { overflowY } = window.getComputedStyle(currentNode);
    const isScrollable = ['auto', 'scroll'].includes(overflowY);
    if (isScrollable && currentNode.scrollHeight > currentNode.clientHeight) {
      return currentNode;
    }
    currentNode = currentNode.parentElement;
  }

  return window;
};

const scrollToTargetTop = (scrollTarget: HTMLElement, container: HTMLElement | Window) => {
  if (container === window) {
    const targetTop = window.pageYOffset + scrollTarget.getBoundingClientRect().bottom;
    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: 'smooth',
    });
    return;
  }

  const containerRect = container.getBoundingClientRect();
  const targetRect = scrollTarget.getBoundingClientRect();
  const targetTop = container.scrollTop + targetRect.bottom - containerRect.top;
  container.scrollTo({
    top: Math.max(targetTop, 0),
    behavior: 'smooth',
  });
};

const isOverlayOverflowViewport = (overlayNode: HTMLElement) => {
  const overlayRect = overlayNode.getBoundingClientRect();
  const viewportHeight = window.visualViewport?.height || window.innerHeight;

  return overlayRect.top < 0 || overlayRect.bottom > viewportHeight;
};

const adjustDropdownPosition = (selectorNode?: HTMLElement | null) => {
  const overlayNode = document.querySelector(METRIC_FILTER_OVERLAY_BOX_SELECTOR);

  if (!(overlayNode instanceof HTMLElement)) {
    return;
  }

  const scrollTarget = getScrollTarget(selectorNode);
  if (!scrollTarget) {
    return;
  }

  const scrollContainer = getScrollableContainer(scrollTarget);
  if (!isOverlayOverflowViewport(overlayNode)) {
    return;
  }

  scrollToTargetTop(scrollTarget, scrollContainer);
};

export const scheduleAdjustDropdownPosition = (selectorNode?: HTMLElement | null) => {
  window.requestAnimationFrame(() => {
    window.setTimeout(() => {
      adjustDropdownPosition(selectorNode);
    }, 50);
  });
};
